import { useMemo } from "react";

import SignalBubble from "./SignalBubble";

import { useAuth } from "@/context/auth-context";
import { useUser } from "@/context/user-context";
import { hydrateRequestSignalBubbles } from "@/routes/request-logs/search/signal-search-utils";
import { useWorkspaceSignalNames } from "@/routes/request-logs/search/useWorkspaceSignalNames";
import { Metadata } from "@/types/requests";

interface RequestDisplaySignalBubblesProps {
  metadata: Metadata;
}

const RequestDisplaySignalBubbles = ({ metadata }: RequestDisplaySignalBubblesProps) => {
  const userToken = useAuth()?.userToken;
  const workspaceId = useUser()?.activeWorkspaceId;
  const signalNamesById = useWorkspaceSignalNames(userToken, workspaceId);

  const signals = useMemo(
    () => hydrateRequestSignalBubbles(metadata, signalNamesById),
    [metadata, signalNamesById],
  );

  if (signals.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-1.5">
      {signals.map(signal => (
        <SignalBubble key={signal.signalId} signal={signal} />
      ))}
    </div>
  );
};

export default RequestDisplaySignalBubbles;
